import type { BehaviorPropertySnapshotSource } from './types';

import { nuxtPropertiesRepository } from '~~/adapters/repositories/nuxt/nuxtPropertiesRepository';

export interface FetchedPropertySnapshotSource {
	commercialId: string;
	property: BehaviorPropertySnapshotSource;
}

/**
 * Looks a property up by commercial id or Mongo id so events recorded without
 * a property can still carry a snapshot. Resolves null on any failure because
 * tracking must never reach the user.
 */
export async function fetchPropertySnapshotSource(
	identifier: string
): Promise<FetchedPropertySnapshotSource | null> {
	try {
		const [property, error] = await nuxtPropertiesRepository.getOne(identifier);
		if (error || !property) return null;
		return { commercialId: property.commercialId, property };
	} catch {
		// Repository already maps errors; a throw here is still only telemetry loss
		return null;
	}
}
